import { useMutation } from '@tanstack/react-query';
import { approvePartnerGroupChannelJoinRequest } from '../services/partnerGroupChannel';

export const useApprovePartnerGroupChannelJoinRequestMutation = (options = {}) => {
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async ({ requestId }) => {
      if (!requestId) {
        throw new Error('Join request id is required to approve.');
      }

      const result = await approvePartnerGroupChannelJoinRequest(requestId);

      if (!result.success) {
        throw new Error(result.message || 'Failed to approve join request');
      }

      return result;
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
